import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getAllTags = async (selectedTenant: string, currentPage: number, searchQuery: string) => {
    if (!selectedTenant) return;
    const url = searchQuery
        ? `${NGROK}/api/tags/search?q=${searchQuery}&page=${currentPage}&size=15`
        : `${NGROK}/api/tags/all?page=${currentPage}&size=15`;
    const data = await apiClient({
        method: "GET",
        url: url + `&tenantName=${selectedTenant}`
    });

    return data;
};

export const createTags = async (payload: any) => {
    const url = `${NGROK}/api/tags/create`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });

    return data;
};

export const updateTag = async (id: string, tagName: string, tenantName: string, tagdescription: string) => {
    const url = `${NGROK}/api/tags/update/${id}?name=${tagName}&description=${tagdescription}`;
    const data = await apiClient({
        method: "PATCH",
        url,
    });
    return data;
}


export const deleteTag = async (tagId: string) => {
    const url = `${NGROK}/api/tags/delete/${tagId}`;
    const data = await apiClient({
        method: "DELETE",
        url
    });

    return data;
};